import React, { useEffect } from "react";
import { Space, Layout, Typography } from "antd";
import { useNavigate } from "react-router-dom";

import FormSignup from "../../components/forms/formSignup";
import { useThemedLogo } from "../../theme/useThemedLogo";

const { Title, Paragraph } = Typography;

export default function Signup() {
  const navigate = useNavigate();
  const logo = useThemedLogo();

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      navigate("/app");
    }
  });

  return (
    <Layout>
      <Space
        direction="vertical"
        align="center"
        style={{
          display: "flex",
          minHeight: "100vh",
          justifyContent: "center",
          padding: "2rem 1.5rem",
        }}
        size="large"
      >
        <div
          style={{
            display: "flex",
            alignItems: "end",
            gap: 15,
            maxWidth: "100%",
          }}
        >
          <img
            src={logo}
            alt="Mailinflow Logo"
            height={60}
            style={{ maxWidth: "100%", height: "auto", maxHeight: 60 }}
          />
        </div>
        <div style={{ textAlign: "center", maxWidth: 480 }}>
          <Title level={2} style={{ marginBottom: 8 }}>
            Create your Mailinflow account
          </Title>
          <Paragraph type="secondary" style={{ marginBottom: 0 }}>
            Tell us a bit about you and we&apos;ll send a one-time password to
            your email to finish setting things up.
          </Paragraph>
        </div>
        <FormSignup />
      </Space>
    </Layout>
  );
}
